import { render } from "./P025.vue?vue&type=template&id=6ff365eb&scoped=true"
import script from "./P025.vue?vue&type=script&lang=js"
export * from "./P025.vue?vue&type=script&lang=js"

import "./P025.vue?vue&type=style&index=0&id=6ff365eb&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff365eb"]])

export default __exports__